import React, { Suspense } from "react";
import { Redirect, Switch } from "react-router-dom";
import { LayoutSplashScreen, ContentRoute } from "../_metronic/layout";
import { BuilderPage } from "./pages/BuilderPage";
import { MyPage } from "./pages/MyPage";
import { DashboardPage } from "./pages/DashboardPage";
import { CustomerPage } from "./pages/customer/CustomerPage";
import { MyPage2 } from "./pages/MyPage2";
import { CustomerCreate } from "./pages/customer/CustomerCreate";
import { ProductPage } from "./pages/product/ProductPage";
import { CompanyPage } from "./pages/company/CompanyPage";
import { CompanyCreate } from "./pages/company/CompanyCreate";
import { VisitPage } from "./pages/visit/VisitPage";
import { VisitCreate } from "./pages/visit/VisitCreate";
import { VisitEdit } from "./pages/visit/VisitEdit";
import { JourneyPage } from "./pages/journey/JourneyPage";
import { JourneyEdit } from "./pages/journey/JourneyEdit";
import { JourneyCreate } from "./pages/journey/JourneyCreate";
import { UomPage } from "./pages/uom/UomPage";
import { UomCreate } from "./pages/uom/UomCreate";
import { ProductCreate } from "./pages/product/ProductCreate";
import { PricelistPage } from "./pages/pricelist/PricelistPage";
import { PricelistCreate } from "./pages/pricelist/PricelistCreate";
import { SettingJourneyPage } from "./pages/setting-journey/SettingJourneyPage";
import { SettingJourneyCreate } from "./pages/setting-journey/SettingJourneyCreate";
import { InitialloadPage } from "./pages/initialload/InitialloadPage";
import { InitialloadCreate } from "./pages/initialload/InitialloadCreate";
import { SettingJourneyRoute } from "./pages/setting-journey/SettingJourneyRoute";
import { OrderPage } from "./pages/order/OrderPage";
import { OrderCreate } from "./pages/order/OrderCreate";
import { AdjustmentStockCreate } from "./pages/adjustment-stock/AdjustmentStockCreate";
import { AdjustmentStockPage } from "./pages/adjustment-stock/AdjustmentStockPage";
import { MenuPage } from "./pages/menu/MenuPage";
import { MenuCreate } from "./pages/menu/MenuCreate";
import { UserPage } from "./pages/user/UserPage";
import { UserCreate } from "./pages/user/UserCreate";
import { RolePage } from "./pages/role/RolePage";
import { RoleCreate } from "./pages/role/RoleCreate";
import { SettingPage } from "./pages/setting/SettingPage";
import { SettingCreate } from "./pages/setting/SettingCreate";
import { CrashReportPage } from "./pages/crash-report/CrashReportPage";
import { CrashReportCreate } from "./pages/crash-report/CrashReportCreate";
import { ParamCreate } from "./pages/param/ParamCreate";
import { ParamPage } from "./pages/param/ParamPage";
import { LicensePage } from "./pages/license/LicensePage";
import { LicenseCreate } from "./pages/license/LicenseCreate";
import { LicenseGenerate } from "./pages/license/LicenseGenerate";
import { DashboardDetailPage } from "./pages/DashboardDetailPage";
import { PolicyCreate } from "./pages/setting/PolicyCreate";
import { PolicyPage } from "./pages/setting/PolicyPage";
import { BranchPage } from "./pages/branch/BranchPage";
import { BranchCreate } from "./pages/branch/BranchCreate";
import { RegulerDiscPage } from "./pages/reguler-disc/RegulerDiscPage";
import { RegulerDiscCreate } from "./pages/reguler-disc/RegulerDiscCreate";
import { SpecialDiscPage } from "./pages/special-disc/SpecialDiscPage";
import { SpecialDiscCreate } from "./pages/special-disc/SpecialDiscCreate";
import { CustomerMaps } from "./pages/customer/CustomerMaps";
import { ApilogPage } from "./pages/apilog/ApilogPage";
import { ApilogCreate } from "./pages/apilog/ApilogCreate";
import { PrivacyPolicyCreate } from "./pages/setting/PrivacyPolicyCreate";
import { ReportPage } from "./pages/report/ReportPage";
import { AreaPage } from "./pages/area/AreaPage";
import { AreaCreate } from "./pages/area/AreaCreate";
import { DistributorPage } from "./pages/distributor/DistributorPage";
import { DistributorCreate } from "./pages/distributor/DistributorCreate";
import { ReportConsolidation } from "./pages/ReportConsolidation";
import { SellInCreate } from "./pages/sell-in/SellInCreate";
import { SellInPage } from "./pages/sell-in/SellInPage";
import { Visibility } from "@mui/icons-material";
import { VisibilityPage } from "./pages/VisibilityPage";
import { SurveyCreate } from "./pages/survey/SurveyCreate";
import { SurveyPage } from "./pages/survey/SurveryPage";
import { ResultPage } from "./pages/result-survey/ResultPage";
import { ResultCreate } from "./pages/result-survey/ResultCreate";
import { ResultSummary } from "./pages/result-survey/ResultSummary";
import { ApkPage } from "./pages/setting/ApkPage";
import { TopPage } from "./pages/top/TopPage";
import { TopCreate } from "./pages/top/TopCreate";
import { ProductSort } from "./pages/product/ProductSort";
import { AccuratePage } from "./pages/accurate/AccuratePage";
import { AccurateCreate } from "./pages/accurate/AccurateCreate";


export default function BasePage() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        {
          /* Redirect from root URL to /dashboard. */
          <Redirect exact from="/" to="/dashboard" />
        }
        <ContentRoute
          path="/dashboard/detail"
          component={DashboardDetailPage}
        />
        <ContentRoute path="/dashboard/visibility" component={VisibilityPage} />
        <ContentRoute path="/dashboard" component={DashboardPage} />
        <ContentRoute path="/builder" component={BuilderPage} />
        <ContentRoute path="/my-page" component={MyPage} />
        <ContentRoute path="/my-page2" component={MyPage2} />

        {/* User */}
        {/* <ContentRoute
          path="/administration/role/permision/:id"
          component={RoleCreate}
        /> */}
        <ContentRoute
          path="/administration/role/edit/:id"
          component={RoleCreate}
        />
        <ContentRoute
          path="/administration/role/create"
          component={RoleCreate}
        />
        <ContentRoute path="/administration/role" component={RolePage} />
        {/* setting */}

        <ContentRoute
          path="/administration/setting/edit/:id"
          component={SettingCreate}
        />
        <ContentRoute path="/administration/setting" component={SettingPage} />
        <ContentRoute path="/administration/apk" component={ApkPage} />

        <ContentRoute
          path="/administration/user/edit/:id"
          component={UserCreate}
        />
        <ContentRoute
          path="/administration/user/create"
          component={UserCreate}
        />
        <ContentRoute path="/administration/user" component={UserPage} />

        {/* Customer */}
        <ContentRoute
          path="/administration/menu/edit/:id"
          component={MenuCreate}
        />
        <ContentRoute
          path="/administration/menu/create"
          component={MenuCreate}
        />
        <ContentRoute path="/administration/menu" component={MenuPage} />

        {/* Customer */}
        <ContentRoute
          path="/master/customer/edit/:id"
          component={CustomerCreate}
        />
        <ContentRoute
          path="/master/customer/create"
          component={CustomerCreate}
        />
        {/* <ContentRoute path="/master/customer/maps" component={CustomerMaps} /> */}
        <ContentRoute path="/master/customer" component={CustomerPage} />

        <ContentRoute path="/master/geolocation-map" component={CustomerMaps} />
        {/* Product */}
        <ContentRoute
          path="/master/product/edit/:id"
          component={ProductCreate}
        />
        <ContentRoute path="/master/product/create" component={ProductCreate} />
        <ContentRoute path="/master/product/sort" component={ProductSort} />
        <ContentRoute path="/master/product" component={ProductPage} />
        {/* company */}
        <ContentRoute
          path="/master/company/edit/:id"
          component={CompanyCreate}
        />
        <ContentRoute path="/master/company/create" component={CompanyCreate} />
        <ContentRoute path="/master/company" component={CompanyPage} />
        {/* company */}

        <ContentRoute path="/visit/create" component={VisitCreate} />
        <ContentRoute path="/visit" component={VisitPage} />
        {/* Journey */}
        <ContentRoute
          path="/transaction/journey/visit/:id"
          component={VisitEdit}
        />
        <ContentRoute
          path="/transaction/journey/detail/:id"
          component={JourneyEdit}
        />
        <ContentRoute
          path="/transaction/journey/create"
          component={JourneyCreate}
        />

        <ContentRoute path="/transaction/journey" component={JourneyPage} />

        {/*  sellIn */}
        <ContentRoute
          path="/transaction/sell-in/edit/:id"
          component={SellInCreate}
        />
        <ContentRoute
          path="/transaction/sell-in/create"
          component={SellInCreate}
        />
        <ContentRoute path="/transaction/sell-in" component={SellInPage} />
        {/* Journey */}
        <ContentRoute path="/master/uom/edit/:id" component={UomCreate} />
        <ContentRoute path="/master/uom/create" component={UomCreate} />
        <ContentRoute path="/master/uom" component={UomPage} />

        <ContentRoute
          path="/master/pricelist/edit/:id"
          component={PricelistCreate}
        />
        <ContentRoute
          path="/master/pricelist/create"
          component={PricelistCreate}
        />
        <ContentRoute path="/master/pricelist" component={PricelistPage} />
        {/* setting Journey */}

        <ContentRoute
          path="/master/journey-setting/route/:id"
          component={SettingJourneyRoute}
        />

        <ContentRoute
          path="/master/journey-setting/edit/:id"
          component={SettingJourneyCreate}
        />
        <ContentRoute
          path="/master/journey-setting/route"
          component={SettingJourneyRoute}
        />
        <ContentRoute
          path="/master/journey-setting/create"
          component={SettingJourneyCreate}
        />

        <ContentRoute
          path="/master/journey-setting"
          component={SettingJourneyPage}
        />

        {/* initial load  */}
        <ContentRoute
          path="/master/initial-load/edit/:id"
          component={InitialloadCreate}
        />
        <ContentRoute
          path="/master/initial-load/create"
          component={InitialloadCreate}
        />
        <ContentRoute path="/master/initial-load" component={InitialloadPage} />
        {/* adjusment */}
        <ContentRoute
          path="/master/adjustment/edit/:id"
          component={AdjustmentStockCreate}
        />
        <ContentRoute
          path="/master/adjustment/create"
          component={AdjustmentStockCreate}
        />
        <ContentRoute
          path="/master/adjustment"
          component={AdjustmentStockPage}
        />
        <ContentRoute
          path="/transaction/order/detail/:id"
          component={OrderCreate}
        />
        <ContentRoute path="/transaction/order" component={OrderPage} />

        {/* crash report */}

        <ContentRoute
          path="/administration/crash-report/edit/:id"
          component={CrashReportCreate}
        />
        <ContentRoute
          path="/administration/crash-report"
          component={CrashReportPage}
        />

        {/* apilog */}

        <ContentRoute
          path="/administration/apilog/edit/:id"
          component={ApilogCreate}
        />
        <ContentRoute path="/administration/apilog" component={ApilogPage} />

        {/* accurate */}

        <ContentRoute
          path="/administration/accurate/edit/:id"
          component={AccurateCreate}
        />
        <ContentRoute
          path="/administration/accurate"
          component={AccuratePage}
        />

        {/* crash report */}

        <ContentRoute
          path="/administration/policy/edit/:id"
          component={PolicyCreate}
        />
        <ContentRoute
          path="/administration/privacy-policy"
          component={PrivacyPolicyCreate}
        />
        <ContentRoute path="/administration/policy" component={PolicyPage} />

        <ContentRoute
          path="/administration/param/edit/:id"
          component={ParamCreate}
        />
        <ContentRoute
          path="/administration/param/create"
          component={ParamCreate}
        />
        <ContentRoute path="/administration/param" component={ParamPage} />

        <ContentRoute
          path="/administration/license/edit/:id"
          component={LicenseCreate}
        />
        <ContentRoute
          path="/administration/license/generate"
          component={LicenseGenerate}
        />
        <ContentRoute
          path="/administration/license/create"
          component={LicenseCreate}
        />
        <ContentRoute path="/administration/license" component={LicensePage} />

        <ContentRoute path="/master/branch/edit/:id" component={BranchCreate} />
        <ContentRoute path="/master/branch/create" component={BranchCreate} />
        <ContentRoute path="/master/branch" component={BranchPage} />

        {/* TOP */}

        <ContentRoute path="/master/top/edit/:id" component={TopCreate} />
        <ContentRoute path="/master/top/create" component={TopCreate} />
        <ContentRoute path="/master/top" component={TopPage} />

        {/* reguler diskon */}
        <ContentRoute
          path="/master/reguler-disc/edit/:id"
          component={RegulerDiscCreate}
        />
        <ContentRoute
          path="/master/reguler-disc/create"
          component={RegulerDiscCreate}
        />
        <ContentRoute path="/master/reguler-disc" component={RegulerDiscPage} />

        {/* special diskon */}
        <ContentRoute
          path="/master/special-disc/edit/:id"
          component={SpecialDiscCreate}
        />
        <ContentRoute
          path="/master/special-disc/create"
          component={SpecialDiscCreate}
        />
        <ContentRoute path="/master/special-disc" component={SpecialDiscPage} />
        {/* report */}
        <ContentRoute
          path="/consolidation-report"
          component={ReportConsolidation}
        />
        {/* report */}
        <ContentRoute path="/report" component={ReportPage} />

        {/*  area */}
        <ContentRoute path="/master/area/edit/:id" component={AreaCreate} />
        <ContentRoute path="/master/area/create" component={AreaCreate} />
        <ContentRoute path="/master/area" component={AreaPage} />

        {/*  Distributor */}
        <ContentRoute
          path="/master/distributor/edit/:id"
          component={DistributorCreate}
        />
        <ContentRoute
          path="/master/distributor/create"
          component={DistributorCreate}
        />
        <ContentRoute path="/master/distributor" component={DistributorPage} />

        {/*  survey  */}
        <ContentRoute path="/survey/form/edit/:id" component={SurveyCreate} />
        <ContentRoute path="/survey/form/create" component={SurveyCreate} />
        <ContentRoute path="/survey/form" component={SurveyPage} />

        {/*  result  */}
        <ContentRoute path="/survey/result/edit/:id" component={ResultCreate} />
        <ContentRoute path="/survey/result" component={ResultPage} />
        <ContentRoute path="/survey/summary" component={ResultSummary} />

        <Redirect to="error/error-v1" />
      </Switch>
    </Suspense>
  );
}
